import { render, staticRenderFns } from "./EconomyStretch.vue?vue&type=template&id=841d5396&scoped=true&"
import script from "./EconomyStretch.vue?vue&type=script&lang=js&"
export * from "./EconomyStretch.vue?vue&type=script&lang=js&"
import style0 from "./EconomyStretch.vue?vue&type=style&index=0&id=841d5396&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841d5396",
  null
  
)

export default component.exports